<tr *ngIf="element !== null" [ngClass]="{'table-active': status.getActiveElement() === element.id}">
  <td class="p-pl-1" style="width:20px;">
      <fa-icon [icon]="faFileInvoice" *ngIf="element.type === 'html'"></fa-icon>
      <fa-icon [icon]="faFileCheck" *ngIf="element.type === 'checklist'"></fa-icon>
      <fa-icon [icon]="faFileUser" *ngIf="element.type === 'test'"></fa-icon>
  </td>
  <td class="pointer" (click)="setActive()">{{element.title}}</td>
  <td class="p-pr-1 p-text-right">
      <fa-icon [icon]="faStreetView" class="p-mr-2 pointer" [ngClass]="{'disabled': element.candidate !== true}" (click)="element.candidate = !element.candidate"></fa-icon>
      <fa-icon [icon]="faUsers" [ngClass]="{'disabled': element.observer !== true}" (click)="element.observer = !element.observer"></fa-icon>
  </td>
</tr>
